import { formatScore } from '@/utils'

export * from './ClimateEngagementScore'
export * from './PerTopicEngagementScore'
export * from './EmployeeReviews'
export * from './Logo'
export * from './OrganisationDetails'
export * from './OrganisationsWrapper'
export * from './List'
export * from './components'
export * from './components/Modal'
export * from './components/Cards'
export * from './Select'

export function parseScoreProgress(progress: number): string {
  if (Number(progress) === 0) return '--%'
  return `${formatScore(progress)}%`
}
